import { IRootState } from '../../../store'
import { IProcedureState } from '../store/procedure.types'

export const getProcedureStateSelector = (state: IRootState): IProcedureState => state.procedure
